/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React from 'react'

import { Typo } from 'ui/theme'

export type LabelVariant = 'title2' | 'title3' | 'body'

export const renderRadioGroupLabel = (label: string, labelVariant: LabelVariant) => {
  const labelComponentByVariant: Record<LabelVariant, React.ElementType> = {
    title2: Typo.Title2,
    title3: Typo.Title3,
    body: Typo.Body,
  }
  return React.createElement(labelComponentByVariant[labelVariant], null, label)
}
